<template>
    <div ref="root">
        <slot />
    </div>
</template>

<script>
import { ref, provide, onBeforeUnmount } from 'vue';
import { useFirstVisible } from '@/composables/useFirstVisible';

/**
 * Types out the <TypedText> inside it one after the other, in render order,
 * starting `delay` ms after it first comes into view. Delays are in ms.
 */
export default {
    name: 'TypeReveal',
    props: {
        delay: { type: Number, default: 0 },
        typeDelay: { type: Number, default: 8 },
    },
    setup(props) {
        const root = ref(null);
        // Characters typed so far, counted across every <TypedText>.
        const typed = ref(0);
        let total = 0;
        let timer = null;

        provide('typeReveal', {
            typed,
            // Each <TypedText> reserves its characters on creation and gets the index of its first one.
            register: (length) => {
                total += length;
                return total - length;
            },
        });

        const type = () => {
            if (typed.value >= total) return;
            typed.value++;
            timer = setTimeout(type, props.typeDelay);
        };

        useFirstVisible(root, () => {
            timer = setTimeout(type, props.delay);
        });
        onBeforeUnmount(() => clearTimeout(timer));

        return { root };
    },
};
</script>
